(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    class BreadcrumbsComponent extends HTMLElement {
      constructor() {
        super();

        this.backHref = this.getAttribute('data-back-href');
        this.backLink = this.querySelector('.breadcrumbs-history-back');
        this.nav = this.querySelector('.breadcrumbs-nav');
        this.isProduct = this.getAttribute('data-is-product') === 'true';
      }

      connectedCallback() {
        if (this.isProduct == true) return;

        const previousURL = document.referrer;

        if (previousURL && this.backHref && previousURL.includes(this.backHref)) {
          this.backLink.classList.remove('hidden');
          this.nav.classList.add('hidden');
        } else {
          this.backLink.classList.add('hidden');
          this.nav.classList.remove('hidden');
        }
      }

      disconnectedCallback() {
        console.log('Breadcrumbs disconnected');
      }
    }

    customElements.define('breadcrumbs-component', BreadcrumbsComponent);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filter-discount"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    class DiscountRange extends HTMLElement {
      constructor() {
        super();

        this.slider = null;
        this.sliderRange = null;
        this.labels = null;
        this.checkboxes = null;
        this.discountValues = null;
        this.typeSort = null;
        this.form = null;
      }

      connectedCallback() {
        this.slider = this.querySelector('#discount-slider-range');
        this.sliderRange = this.querySelector('#slider-range');
        this.labels = this.querySelectorAll('.discount-range__labels span');
        this.checkboxes = this.querySelectorAll('.checkbox-discount');
        this.discountValues = this.slider.getAttribute('data-steps').split(',');
        this.typeSort = this.getAttribute('data-type-sort');
        this.form = this.closest('form');

        this.boundChangeRange = this.changeRange.bind(this);

        this.slider?.addEventListener('input', this.boundChangeRange);
        this.labels.forEach((label, index) => {
          label.addEventListener('click', () => {
            this.slider.value = index;
            this.boundChangeRange();

            const changeEvent = new Event('change', { bubbles: true });
            this.slider.dispatchEvent(changeEvent);
          });
        });
      }

      disconnectedCallback() {
        this.slider?.removeEventListener('input', this.boundChangeRange);
      }

      changeRange() {
        const value = parseInt(this.slider.value);
        const percentage = value === 0 ? 0 : (value / (this.discountValues.length - 1)) * 100;
        this.sliderRange.style.width = percentage + '%';

        const selectedDiscount = this.discountValues[value];

        this.labels.forEach((label, index) => {
          if (index === value) {
            label.classList.add('active');
          } else {
            label.classList.remove('active');
          }
        });

        this.checkboxes.forEach((checkbox) => {
          const checkboxValue = checkbox.dataset.discountValue;

          if (selectedDiscount === 'all') {
            checkbox.checked = false;
          } else {
            const discountNum = parseInt(checkboxValue.replace('%', ''));
            const selectedNum = parseInt(selectedDiscount);
            if (this.typeSort == 'single') {
              checkbox.checked = discountNum == selectedNum;
            } else {
              const shouldCheck = this.typeSort === 'desc' ? discountNum <= selectedNum : discountNum >= selectedNum;
              checkbox.checked = shouldCheck;
            }
          }
        });
      }
    }

    if (!customElements.get('discount-range')) {
      customElements.define('discount-range', DiscountRange);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
